import React, { useEffect, useState } from 'react';
import { detectIncognito } from "detectincognitojs";
import Cookies from "js-cookie";

// Function to generate a unique browser key
const generateBrowserKey = () => {
    const userAgent = navigator.userAgent;
    const screenResolution = `${window.screen.width}x${window.screen.height}`;
    const timezoneOffset = new Date().getTimezoneOffset();

    const browserKey = btoa(`${userAgent}-${screenResolution}-${timezoneOffset}`);
    return browserKey.substring(0, 32); // Limit to 32 characters
};

const CheckingBrowser = () => {
    const [browserKey, setBrowserKey] = useState(null);
    const [isIncognito, setIsIncognito] = useState(null);

    useEffect(() => {
        // Generate and store browser key
        const key = generateBrowserKey();
        setBrowserKey(key);
        Cookies.set("browser_key", key, { expires: 1 });
        localStorage.setItem("browser_key", key);
        //console.log("Generated Browser Key:", key);
    }, []);

    useEffect(() => {
        if (browserKey) {
            let isMounted = true; // To prevent state updates if unmounted

            const checkIncognitoMode = async () => {
                try {
                    const result = await detectIncognito();
                    if (isMounted) {
                        setIsIncognito(result.isPrivate);
                        Cookies.set("browser_type", result.isPrivate, { expires: 1 });
                        localStorage.setItem("browser_type", result.isPrivate);
                        //console.log("Browser Type (Incognito):", result.isPrivate);
                    }
                } catch (error) {
                    console.error("Error detecting incognito mode:", error);
                }
            };

            checkIncognitoMode();

            return () => {
                isMounted = false; // Cleanup on unmount
            };
        }
    }, [browserKey]);

    return null; // No rendering required
};

export default CheckingBrowser;
